import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Tabs from 'components/common/Tabs'
import Theme from 'components/common/Theme/Theme'
import { BazaarVoiceReviewsSummary, BazaarVoiceReviews } from 'components/BazaarVoice'
import OverviewTab from './components/OverviewTab'

const TabsTireDetails = ({
  productId,
  reviewsCount,
  tabsConfig,
  tabToActivate,
  eventName,
  ...props
}) =>
  <StyledTabs menu={ tabsConfig } eventName={ eventName } tabToActivate={ tabToActivate }>
    <OverviewTab { ...props } />
    {
      reviewsCount ?
        <StyledBazaarVoiceReviews productId={ productId } /> :
        <StyledBazaarVoiceReviewsSummary productId={ productId } reviewsHeading />
    }
  </StyledTabs>

export default TabsTireDetails

TabsTireDetails.propTypes = {
  eventName: PropTypes.string,
  productId: PropTypes.string,
  productReviewsContainer: PropTypes.string,
  reviewsCount: PropTypes.number,
  tabsConfig: PropTypes.arrayOf(PropTypes.shape()),
  tabToActivate: PropTypes.number
}

const StyledBazaarVoiceReviews = styled(BazaarVoiceReviews)`
  ${Mixin.responsive('padding', '20px 50px 110px', '20px 16px 90px')}

  .bv-cv2-cleanslate .bv-core-container-90 {
    .bv-rating-stars-off {
      color: ${Theme.colors.medium_grey_ui} !important;
    }

    .bv-content-secondary-ratings-container,
    .bv-secondary-rating-summary-bars-container .bv-secondary-rating-summary-bars {
      background-color: ${Theme.colors.medium_grey_ui} !important;
    }
  }
`

const StyledBazaarVoiceReviewsSummary = styled(BazaarVoiceReviewsSummary)`
  ${Mixin.responsive('padding', '20px 50px 110px', '20px 16px 90px')}
`

const StyledTabs = styled(Tabs)`
  ${Mixin.responsive('padding-left', '50px', '6px')}
`
